import { SimulationLinkDatum } from 'd3-force'
import { observable } from 'mobx'
import GNode from './node'
import { IProps, IStyle, LINK_STYLE } from './types'

class GLink implements SimulationLinkDatum<GNode> {
    public id: string
    public index: number
    @observable public selected: boolean = false
    @observable public highlight: boolean = false
    public source: GNode
    public target: GNode
    public type: string
    public style: IStyle
    public aggregation: boolean
    public props: IProps
    public aggregationProps: Map<number, IProps> = new Map()

    constructor(link: any, source: GNode, target: GNode) {
        this.id = `${link.id}`
        // this.index = link.id
        this.source = source
        this.target = target
        this.type = link.type
        this.props = link.props
        if (link.type === 'Contract') {
            this.style = LINK_STYLE.CONTRACT
        } else if (link.type === 'Own') {
            this.style = LINK_STYLE.OWN
        } else {
            this.style = LINK_STYLE.DEFAULT
        }
    }
}
export default GLink
